/* unplugin-vue-components disabled */import { render } from "./popover.vue?vue&type=template&id=ddf6a3b6"
import script from "./popover.vue?vue&type=script&lang=js"
export * from "./popover.vue?vue&type=script&lang=js"

import "./popover.vue?vue&type=style&index=0&id=ddf6a3b6&lang=stylus"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/controls/popover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ddf6a3b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ddf6a3b6', __exports__)) {
    api.reload('ddf6a3b6', __exports__)
  }
  
  module.hot.accept("./popover.vue?vue&type=template&id=ddf6a3b6", () => {
    api.rerender('ddf6a3b6', render)
  })

}


export default __exports__